import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

// В @ant-design/icons нет знака @, поэтому рисуем его сами
const AtSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none'>
    <circle
      cx='12'
      cy='12'
      r='4'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const AtIcon: React.FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={AtSvg} {...props} />
)
